'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | 5 Dec 2019
 * `en-us` | Dec 5 2019
 * `es` | 5 dic 2019
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format_new/short_date/name
 */
var form = 'short_date';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format_new', form, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
